export const formatAddress = (address) => {
  const addressParts = [address.city, address.countryNormalized].filter(Boolean)
  return addressParts.join(", ")
}
